var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:_vm.$store.state.common.theme !=3 ?'footer' :'footer footer_3'},[_c('p',{class:[_vm.canClick?'canclick':'',_vm.$store.state.common.theme !=3 ? '':'canclick_color'],on:{"click":function($event){$event.stopPropagation();return _vm.btnClick.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }